<template>
	<ColorConfigurator
		v-if="parametrics?.color"
		:parametrics-color="parametrics.color"
	/>
	<SecondParametricConfigurator
		v-if="parametrics?.[getSecondParametricName(parametrics)]"
		:parametrics-second-one="
			parametrics?.[getSecondParametricName(parametrics)]
		"
	/>
</template>

<script setup lang="ts">
import type { GroupedParametrics } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import ColorConfigurator from "./ColorConfigurator.vue";
import SecondParametricConfigurator from "./SecondParametricConfigurator.vue";

interface Props {
	parametrics: GroupedParametrics | undefined;
}
const { parametrics } = defineProps<Props>();

const { getSecondParametricName } = useNorcePwa();
</script>
